import { useViewportSize } from "@mantine/hooks";
import React               from "react";

import useStyles from "_styles/pages/blogs/homePage.js";

import CategorySection from "./categorySection.js";
import FeaturedPost    from "./featuredPost.js";

const homePage = ( { categories } ) => {
	const { width }   = useViewportSize ();
	let deviceViewTab = width && width <= 1250;
	const { classes } = useStyles ( { deviceViewTab }, { name: "blogsHomePage" } );

	return (
		<div className = { classes.blogPageContainer }>

			<FeaturedPost
				categories = { categories }
			/>

			{categories?.map ( cat => {
				if ( cat?.name === "Featured" || !cat?.posts?.length ) return null;

				return (
					<CategorySection
						key      = { cat?.categoryId }
						category = { cat }
					/>
				);
			} )}

		</div>
	);
};

export default homePage;
